import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const columns = (renderValueCell, cuttingData) => [
  {
    field: 'diameter',
    headerName: `Diameter (${cuttingData?.diameter.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(cuttingData?.diameter?.decimals));
    },
  },
  {
    field: 'thickness',
    headerName: `Thickness (${cuttingData?.thickness.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(cuttingData?.thickness?.decimals));
    },
  },
  {
    field: 'density',
    headerName: `Density (${cuttingData?.density.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(cuttingData?.density?.decimals));
    },
  },
  {
    field: 'porosity',
    headerName: `Porosity (${cuttingData?.porosity.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(cuttingData?.porosity?.decimals));
    },
  }
];
export default columns;
